import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'
import { CREATION_BLOCKS } from 'components/pages/create/create'

const { PUBLIC_MONEY_POOL } = POOLS_CAMPAIGN_TYPES

export function getBlockType(state, props, campaign) {
  let blockType
  if (
    state.current_user.moneypools_account_type_blocked &&
    props.params.nextStep !== 'types' &&
    (campaign.campaign_type === PUBLIC_MONEY_POOL ||
      !state.current_user.enable_crowdfunding_business_account)
  ) {
    blockType = CREATION_BLOCKS.byAccountType
  } else if (state.current_user.moneypools_country_blocked) {
    blockType = CREATION_BLOCKS.byCountry
  } else if (!state.flags.allow_creation) {
    blockType = CREATION_BLOCKS.byKillSwitch
  } else if (!state.current_user.email_confirmed) {
    blockType = CREATION_BLOCKS.byUnconfirmed
  }
  return blockType
}
